import { useDispatch } from 'react-redux'
import { clearAuditTrailsState } from '../store/reducers/auditTrailReducer'
import { clearDataSourceState } from '../store/reducers/dataSourceReducer'
import { clearDataStoreState } from '../store/reducers/dataStoreReducer'
import { clearLangagueState } from '../store/reducers/languageReducer'
import { clearSearchReviewState } from '../store/reducers/searchReviewReducer'
import { clearOfrState } from '../store/reducers/ofrDocumentTemplateReducer'
import { clearSearchResultState } from '../store/reducers/searchResultInfoReducer'
import { clearThemeState } from '../store/reducers/themeReducer'
import { clearUserState } from '../store/reducers/userReducer'
import { clearWorkspaceState } from '../store/reducers/workspaceReducer'

const useClearStore = () => {
  const dispatch = useDispatch()
  const clearStore = () => {
    dispatch(clearSearchResultState())
    dispatch(clearDataSourceState())
    dispatch(clearSearchReviewState())
    dispatch(clearUserState())
    dispatch(clearDataStoreState())
    dispatch(clearWorkspaceState())
    dispatch(clearAuditTrailsState())
    dispatch(clearOfrState())
    dispatch(clearLangagueState())
    dispatch(clearThemeState())
  }
  return clearStore
}

export default useClearStore
